// extracted by mini-css-extract-plugin
module.exports = {"filterBox":"FilterForm_filterBox__2h5Ta"};